import { IHttpService } from "../HttpService";
import Language, { ILanguage } from "../../model/language/Language";

export interface ILanguageService {
  getLanguages(): Promise<ILanguage[]>;
  changeLanguage(languageCode: number): Promise<any>;
  getLanguage(langaugeCode: number): Promise<any>;
}

const LanguageService = (httpService): ILanguageService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _languagesPath = "languages";

  const LanguageListMapper = (json = []) => {
    return json.map((item: any) => {
      return Language(item);
    });
  };

  return {
    async getLanguages() {
      const path = _http.buildPath(_baseUrl, _languagesPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return LanguageListMapper(responseJSON);
    },

    async changeLanguage(languageCode: number) {
      const path = _http.buildPath(_baseUrl, _languagesPath);
      const response = await _http.put(path, {
        params: {
          code: languageCode
        },
        form: true
      });
      return _http.toText(response);
    },

    async getLanguage(langaugeCode: number) {
      const path = _http.buildPath(
        _baseUrl,
        _languagesPath,
        langaugeCode.toString()
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return responseJSON;
    }
  };
};

export default LanguageService;
